<template>
	<div id="orthoTreatmentStagesDiv" class="ortho-controls">
		<button class="ortho-button orto-report-button" v-on:click="anatomyChangeReportClick()">
			ANATOMY CHANGE REPORT
		</button>

		<button id="ortoVideoBtn" class="ortho-button orto-video-button" v-on:click="generateVideoClick()">
			<span class="orto-video-span">GENERATE VIDEO</span>
			<img id="ortoVideoImg" class="orto-video-img" src="images/dark-blue-spinner.gif" />
		</button>

		<div id="orthoTreatmentSlider" class="ortho-report-invisible">
			<div id="playTreatmentSlider" class="horizontal-slider"></div>

			<img id="orthoTreatmentBtn" class="ortho-play-img" v-on:click="playTreatmentClick()"
				:src="isTreatmentPlaying ? 'images/pause.png' : 'images/play.png'" />

			<img id="orthoTreatmentCloseBtn" class="ortho-play-img" v-on:click="closeTreatmentPlay()"
				src="images/cross.png" />
		</div>

		<div id="orthoTreatmentStages" class="ortho-report-invisible">
			<button v-for="(stage, index) in treatmentStages" :key="stage.name"
				v-bind:style="{ left: 'calc(' + index * proportion + '% - 17px)' }"
				v-on:click="clickTreatmentStage(stage.id)" :title="stage.name"
				class="ortho-stage ortho-stage-mid ui-button ui-widget ui-corner-all">
				{{ "S" + stage.id }}
			</button>

			<span v-for="(stage, index) in treatmentStages" :key="stage.id"
				v-bind:style="{ left: 'calc(' + index * proportion + '% - 8px)', top: '-31px' }"
				v-on:click="clickTreatmentStage(stage.id)" :title="stage.name"
				class="ui-slider-handle ui-corner-all ui-state-default ortho-ellipse"></span>

		</div>

	</div>
</template>

<script>

import { switchTreatmentPlay, applyTreatmentStage, switchTreatmentShowOriginal, switchTreatmentShowCollisions, exitTreatmentPlayMode } from "./OrthoTreatment";
import { anatomyChangeReport } from "../OrtoReporting";
import { clearOrtoAccesories, leaveOrthoPlanMode } from "../OrthoPlanMode";
import { recordTreatmentVideo } from "@/components/ortho/treatment/OrthoTreatmentVideo";

export default {
	name: "OrthoTreatmentStages",
	props: ["treatmentStages", "isTreatmentPlaying"],
	data() {
		return {
			windowWidth: window.innerWidth
		};
	},
	methods: {
		generateVideoClick: function () {
			if (vueApp.backgroundMessage)
				return;
			recordTreatmentVideo();
		},
		anatomyChangeReportClick: function () {
			switchTreatmentShowOriginal(false);
			switchTreatmentShowCollisions(false);
			anatomyChangeReport();
		},
		playTreatmentClick: function () {
			switchTreatmentPlay(!vueApp.isTreatmentPlaying);
		},
		clickTreatmentStage: function (stageId) {
			applyTreatmentStage(stageId);
			vueApp.isTreatmentPlaying = false;
			switchTreatmentPlay(false);
		},
		closeTreatmentPlay: function () {
			$("#orthoTreatmentStagesDiv").css("display", "none");
			$("#orthoTreatmentDiv").css("display", "none");
			vueApp.isTreatmentPlaying = false;
			switchTreatmentPlay(false);
			exitTreatmentPlayMode();
			vueApp.leaveModes();
		},
	},
	computed: {
		proportion: function () {
			return 100 / (this.treatmentStages.length - 1);
		}
	},
	mounted: function () {
		window.addEventListener("resize", () => {
			this.windowWidth = window.innerWidth;
		});
	}
};
</script>

<style>
.ortho-button {
	display: inline-block;
	min-width: 90px;
	width: auto;
	height: 35px;
	border: 0;
	cursor: pointer;
	font-size: small;
	background-color: #4687fc;
	text-align: center;
	color: #ffffff;
}

.orto-report-button {
	position: absolute;
	width: 220px;
	bottom: 80px;
	left: calc(50% - 110px);
}

.orto-video-button {
	position: absolute;
	min-width: 159px;
	bottom: 80px;
	left: calc(50% + 120px);
	padding-left: 14px;
	cursor: pointer;
	/* cursor: not-allowed; */
}

.orto-video-span {
	display: inline-block;
	vertical-align: middle;
}

.orto-video-img {
	/* display: inline-block; */
	display: none;
	width: 32px;
	height: 32px;
	vertical-align: middle;
}

#orthoTreatmentStagesDiv {
	position: absolute;
	text-align: center;
	left: 10px;
	bottom: 65px;
	z-index: 999;
	display: none;
	width: calc(100% - 215px);
	height: 70px;
}

#orthoTreatmentSlider {
	text-align: center;
	white-space: nowrap;
	width: 100%;
	height: 35px;
}

#orthoTreatmentStages {
	position: absolute;
	text-align: center;
	white-space: nowrap;
	width: calc(100% - 105px);
	height: 35px;
	top: 40px;
	left: 15px;
}

.ortho-stage {
	position: absolute;
	padding: 2px;
	font-size: small;
	width: 65px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.ortho-stage-mid {
	width: 27px;
}

.ortho-ellipse {
	position: absolute;
	padding: 3px;
	height: 25px;
}

.horizontal-slider {
	/*position: relative;*/
	width: calc(100% - 105px);
	border-radius: 0;
	outline: none;
	height: 0.4em;
	margin-left: 5px;
	margin-right: 5px;
	display: inline-block;
}

.horizontal-slider .ui-slider-range {
	display: none;
}

.horizontal-slider .ui-slider-handle {
	outline: none;
	width: 1.6em;
	height: 1.6em;
	border-radius: 30px;
	top: -0.6em;
	margin-left: -0.9em;
}

.ortho-play-img {
	width: 40px;
	cursor: pointer;
	display: inline-block;
}

#orthoTreatmentBtn {
	margin-left: 2px;
}

#originalTreatmentStage {
	left: -15px;
	width: 55px;
}

@media screen and (max-width: 650px) {
	#orthoTreatmentStagesDiv {
		left: 5px;
		bottom: 60px;
		width: calc(100% - 5px);
	}

	.ortho-stage {
		padding: 1px;
	}

	#originalTreatmentStage {
		width: 27px;
	}
}
</style>